import { reviewableRequestsService } from '@api/reviewable_requests.service'
import { RecordFactory } from '@js/records/factory'
import { Paginator } from '@js/helpers/paginator'

function getInitialState () {
  return {
    withdrawals: new Paginator(RecordFactory.createWithdrawRecord.bind(RecordFactory))
  }
}

const state = getInitialState()

const mutations = {
  SET_LOGGED_OUT_STATE (state) {
    Object.assign(state, getInitialState())
  }
}

const actions = {
  async GET_WITHDRAWALS ({ state }, filters) {
    await reviewableRequestsService.loadWithdrawalsRequests(filters)
    state.withdrawals.attachInitLoader(() => reviewableRequestsService.loadWithdrawalsRequests(filters))
    return state.withdrawals.init()
  },

  async NEXT_WITHDRAWALS ({ state }, filters) {
    const records = state.withdrawals.next(filters)
    // restore loaders state
    state.withdrawals.attachInitLoader(() => reviewableRequestsService.loadWithdrawalsRequests(filters))
    return records
  }
}

const getters = {
  withdrawals: state => state.withdrawals
}

export default {
  actions,
  getters,
  mutations,
  state
}



// WEBPACK FOOTER //
// ./src/vuex/modules/withdrawals.module.js